@let blok = block();

<img [ngSrc]="blok.asset.filename" width="20" height="20" [attr.aria-hidden]="blok.isDecorative" [attr.alt]="blok.isDecorative ? '' : blok.asset.alt" class="mr-4">
<span class="break-words">{{ blok.text }}</span>
